var config = require("./Configuration");

/**
 * @implements {AbstractView}
 * @constructor
 */
function BaseGeneralAppConfigView() {
    var $content = $(require("html!./general_app_config_view.html"));

    var allFields = $content.find("[data-config-key]");
    allFields.on("change", function() {
        config.set($(this).attr("data-config-key"), $(this).val());
    });

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "GeneralAppConfig";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("common::general.title"),
            i18n : "common::general.title"
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "menu";
    };

    var super_show = this.show;
    /**
     * @override
     * @inheritDoc
     */
    this.show = function() {
        allFields.each(function() {
            $(this).val(config.get($(this).attr("data-config-key")));
        });
        $content.find("select").selectmenu("refresh");

        super_show.call(this);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.requiresAuthentication = function() {
        return false;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return true;
    };
}

BaseGeneralAppConfigView.prototype = require("common/AbstractView");

module.exports = BaseGeneralAppConfigView;


//////////////////
// WEBPACK FOOTER
// ./settings/BaseGeneralAppConfigView.js
// module id = 89
// module chunks = 0 3